import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  //   在发送请求之前做些什么
  //   此处为解构赋值,不然parmas会被覆盖
  config.params = {
    ...config.params
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

export default axios
